import { useMemo } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { QueryProps } from '@quantum/tools/mfeModule';
import { MarkerProps } from '../types/Tile';

export const useQueryMarker = (props: { model: MarkerProps }) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const moduleName = useMemo(() => props.model.markerModule?.replace('./', '') ?? '', [props.model.markerModule]);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const status = useSelector((state: any) => state.graph?.tiles[moduleName]?.status ?? state.graph?.status);

  const data = useSelector(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (state: any) => {
      const tile = state.graph?.tiles?.[moduleName];
      if (tile && tile.data && tile.root) {
        return { [`${tile.root}`]: tile.data };
      }
      return undefined;
    },
    shallowEqual
  );

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const errors = useSelector((state: any) => state.graph?.tiles[moduleName]?.errors);
  const tileLoadedKey = `${props.model.markerUrl}-${props.model.markerModule?.replace('./', '')}`;
  const tilesLoadedKey = 'loaded-tiles';

  const setCached = (mfeKey: string) => {
    const loadedTiles = JSON.parse(window.sessionStorage.getItem(tilesLoadedKey) ?? '{}');
    if (!loadedTiles[tileLoadedKey]) {
      loadedTiles[tileLoadedKey] = mfeKey;
      window.sessionStorage.setItem(tilesLoadedKey, JSON.stringify(loadedTiles));
    }
  };

  const tileProps = { ...props.model.tileProps, query: { status, data, errors, setCached } as QueryProps };

  const model = { ...props.model, tileProps } as MarkerProps;

  return { ...props, model };
};
